import { createAction, createReducer } from "redux-act";
import { produce } from "immer";

import { reducerRegistry } from "./reducerRegistry";
import { RootState } from "./reducers";
import { UserInfo } from "../evergis/core/user/UserInfo";

export const reducerName = "user";

export type UserState = UserInfo | null;

const initialState: UserState = null;

export const getUser = ({ user }: RootState): UserInfo => user;

export const getUsername = ({ user }: RootState): string => user?.username;

export const getWorkspace = ({ user }: RootState): string => user?.workspace;

export const setUser = createAction<UserInfo>("user/setUser");

export const getProfilePhoto = ({ user }: RootState): string => user?.profilePhoto;

export const setProfilePhoto = createAction<string>("user/setProfilePhoto");

export const reducer = createReducer({}, initialState);

reducer.on(setUser, (state, user) => ({ ...state, ...user }));

reducer.on(
  setProfilePhoto,
  produce((state, profilePhoto: string) => {
    state.profilePhoto = profilePhoto;
  }),
);

reducerRegistry.register(reducerName, reducer);
